import { Component, OnInit } from '@angular/core';
import { LabeledProductService } from '../../services/labeledproduct.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryService } from '../../../common/services/category.service';
import { DistributorService } from '../../../distributors/services/distributor.service';

import { Observable } from 'rxjs/Observable';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-list-labeledproduct-min-stock',
  templateUrl: './list-labeledproduct-min-stock.component.html',
  styleUrls: ['./list-labeledproduct-min-stock.component.css'],
  providers:[LabeledProductService,CategoryService,DistributorService]
})
export class ListLabeledProductMinStockComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  labeledProducts: any = [];
  distributors: any = [];
  filteredDistributors: any =[];
  selectedDistributor: string="";
  filters:any = {
    barcode:{contains: ""},
    name:{contains: ""},
    short_description:{contains: ""},
    manufacturer_barcode:{contains: ""},
    provider_nif:{contains: ""}
  };
  exportParams:any ={};
  showExportButton:boolean = true;
  config: any = {'sourceField': ['name']};
  selectedImage: any = null;
  role:number = 3;


  constructor(private labeledProductService: LabeledProductService, private route: ActivatedRoute, private router: Router,private distributorService:DistributorService) { }

  ngOnInit() {
    this.getLabeledProducts();
    this.getDistributors();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  get(value){
    if (value.id){
      this.filters.distributor = value.id;
    }else{
      delete this.filters.distributor;
    }
    this.getLabeledProducts();
  }

  filterDistributors(value){
    this.selectedDistributor = value;
    this.filteredDistributors = _.filter(this.distributors, function(o) { return o.name.toLowerCase().includes(value.toLowerCase()); });
    if (value == ""){
      delete this.filters.distributor;
      this.getLabeledProducts();
    }
  }

  getDistributors(){
    this.distributorService.query({})
    .subscribe((distributors) => {
        this.distributors = distributors;
        this.filteredDistributors = distributors;
    }); 
  }
  
  getLabeledProducts(){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    this.exportParams = params;
    this.labeledProductService.queryWithMinStock(params)
      .subscribe((labeledProducts) => {
          this.labeledProducts = labeledProducts;
          labeledProducts.forEach((labeledProduct)=>{
            this.getProductPhotos(labeledProduct);
          });
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.labeledProductService.countWithMinStock(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
      });
  }


  getProductPhotos(labeledProduct){
    this.labeledProductService.getProductPhotos(labeledProduct.id)
    .subscribe((result) => {
      labeledProduct.image = result[0].image;
    })
  }

  exportLabeledProductsToExcel(){
    this.showExportButton = false;
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Código de barras",
              field2:"Código de barras del fabricante",
              field3:"Nombre",
              field4:"Stock",
              field5:"Stock Mínimo",
              field6:"Distribuidor"
              
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      let observableLabeledProductsRequest = [];
      let request = Math.ceil(this.totalItems / 100);
      for (let i=0; i<request;i++){
        this.exportParams.skip = ((i)*100),
        this.exportParams.limit = 100
        observableLabeledProductsRequest.push(this.labeledProductService.queryWithMinStock(this.exportParams));        
      }
      Observable.forkJoin(observableLabeledProductsRequest)
          .subscribe(data => {
            let p:any = data;
            let labeledProducts = p.flat(); 
                labeledProducts.forEach(labeledproduct =>{
                  if (labeledproduct.name){
                    labeledproduct.name = labeledproduct.name.replace(/</g, '');
                    labeledproduct.name = labeledproduct.name.replace(/>/g, '');
                    labeledproduct.name = labeledproduct.name.replace(/;/g, '');
                  }
                  var row = {
                      field1:labeledproduct.barcode?labeledproduct.barcode:"",
                      field2:labeledproduct.manufacturer_barcode?labeledproduct.manufacturer_barcode:"",
                      field3:labeledproduct.name?labeledproduct.name:"",
                      field4:labeledproduct.stock?labeledproduct.stock:"",
                      field5:labeledproduct.min_stock_quantity?labeledproduct.min_stock_quantity:"",
                      field6:labeledproduct.distributor?labeledproduct.distributor.name:"",
                  }
                  report.push(row);
              });
              var mystyle = {   
                  headers:true,       
                  columns:    
                      [{columnid:'field1',width:100,title: ''},   
                      {columnid:'field2',width:100,title: ''},
                      {columnid:'field3',width:100,title: 'LISTADO DE PRODUCTOS ETIQUETADOS'},
                      {columnid:'field4',width:300,title: ''},
                      {columnid:'field5',width:100,title: ''},
                      {columnid:'field6',width:100,title: ''}
                      
                      ],
                  /*header*/
                
                  column: {  
                      style:{
                          Alignment:{
                              Horizontal:"Center",
                              Vertical:"Center",  
                              WrapText:1
                              
                          },
                          Font:{
                              Bold:"1",
                              Color:"#000000",
                              Size:10
                          },
                          
                          Interior:{
                              Color:"#7CEECE",
                              Pattern:"Solid"
                          }
                      }},
                cells: {    
                      0:{
                          0:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid",
                                      },
                              Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                  },  
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                              },                        
                              }  
                          },
                          1:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                          },  
                              Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                  }
                          },
                          2:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      }, 
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          }                
                                  }
                              },
                          3:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                                    
                                  }
                              },
                          4:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },
                          5:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              }, 
                      }   
                },
          };
          this.showExportButton = true;
          alasql.promise('SELECT * INTO XLSXML("ProductosEtiquetados_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
        });
  }

  selectImage(src){
    window.scroll(0,0);
    this.selectedImage = src;
  }
  unselectImage(){
    this.selectedImage = null;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/labeledproducts/components/list-labeledproduct-min-stock/list-labeledproduct-min-stock.component.ts